import React from 'react'
import styled, { css } from 'styled-components'
import Image from 'gatsby-image/withIEPolyfill'

const ImageCSS = css``

const DOMImage = styled.img`
  ${ImageCSS};
`

const GatsbyImage = styled(Image)`
  ${ImageCSS};
`

function Media({ className, src, style, alt, objectFit, objectPosition }) {
  const regular =
    !src.localFile ||
    (src.url && src.url.localFile && src.url.localFile.publicURL) ||
    (src.localFile && src.localFile.publicURL)

  if (regular) {
    let url = ''

    if (src.url && src.url.localFile && src.url.localFile.publicURL) {
      url = src.url.localFile.publicURL
    } else if (src.localFile && src.localFile.publicURL) {
      url = src.localFile.publicURL
    } else {
      url = src.url
    }

    return (
      <div
        style={{
          overflow: 'hidden',
          position: 'relative',
          ...style,
        }}
        className={`gatsby-image-wrapper ${className}`}
      >
        <picture>
          <DOMImage src={url} alt={alt} />
        </picture>
      </div>
    )
  }

  return (
    <GatsbyImage
      className={className}
      fluid={src.localFile.childImageSharp.fluid}
      style={style}
      objectFit={objectFit}
      objectPosition={objectPosition}
    />
  )
}

export default Media
